export default __webpack_public_path__ + "static/media/plus.efe465a4.svg";